export default {"src":"https://fishbrain.com/_next/static/media/sunset.6b42d387.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};